import React from 'react'

import useHttp from '@caudena/core/useHttp'
import { AssetsData } from '../../../types/Settings'

import baseAssets from './baseAssets'
import { AssetsSuggestCore } from '@caudena/core/ui-kit'
import { CoinType } from '../../../types/coin'
import { getConfig } from '@caudena/core/useConfig'

interface AssetProps {
  value?: string
  onChange?: (value: string | number | null, currency?: CoinType) => void
}

const AssetSuggest = ({ value, onChange }: AssetProps) => {
  const { data: source } = useHttp<AssetsData>(
    `${getConfig()?.COMPLIANCE_API}/api/settings/assets`
  )

  const data = React.useMemo(
    () =>
      (source ? [...baseAssets, ...source] : baseAssets).map((asset) => ({
        ...asset,
        blockchain: asset?.blockchain.toLowerCase() as CoinType,
      })),
    [source]
  )

  return (
    <AssetsSuggestCore
      availableAssets={data}
      value={value}
      onChange={onChange}
    />
  )
}

export default AssetSuggest
